import m, {type Children, MithrilComponent} from '@bitstillery/mithril'
import {rich_text} from '@bitstillery/common/cms/lib/inline_markup'

import type {CmsComponentMeta} from '@bitstillery/common/cms/catalog_meta'

export const listMeta = {
    tier: 'content',
    summary: 'Bulleted, numbered, or checkmark list; `items` is a prop, not raw list markup.',
    when_to_use:
        'Use `type="check"` for teal checkmark lists. Items may be plain text or inline vnodes; inline markup ' +
        'in a placeholder translation (`<i>`, `<b>`, `<br>`, `<a href>`) is rendered.',
    example: `
    <List items={['Verified suppliers', 'Live stock levels', 'One invoice']} type="check" />
    `,
} satisfies CmsComponentMeta

export interface ListAttrs {
    /** One entry per list item — plain text or inline vnodes (`Text`, `Link`). */
    items: Children[]
    /** `bullet` (default) · `number` (ordered) · `check` (teal checkmarks, ex-CheckmarkList). */
    type?: 'bullet' | 'number' | 'check'
}

/** Bulleted, numbered, or checkmark list. Items are a prop (no raw `<li>` in the catalog). */
export class List extends MithrilComponent<ListAttrs> {
    view(vnode: m.Vnode<ListAttrs>) {
        const type = vnode.attrs.type ?? 'bullet'
        const items = Array.isArray(vnode.attrs.items) ? vnode.attrs.items : []
        const className = `c-list c-list-${type}`
        const entries = items.map((item, i) => <li key={i}>{rich_text(item)}</li>)
        return type === 'number' ? <ol className={className}>{entries}</ol> : <ul className={className}>{entries}</ul>
    }
}
